import React from 'react';
import { useInfiniteHits } from 'react-instantsearch';
import { Button } from 'antd';
import {SearchConfiguration} from "../../interfaces/OrgDetail.interface";
import {CustomHit, HitInterface} from "./CustomHit";

interface CustomInfiniteHitsProps {
    searchConfig: SearchConfiguration,
    onHitSelected: (hit: HitInterface, deeplink: string, imageUrl: string) => void,
}

const CustomInfiniteHits = ({ onHitSelected, searchConfig }: CustomInfiniteHitsProps) => {
    const { hits, isLastPage, showMore } = useInfiniteHits<HitInterface>();

    return (
        <div className="ais-InfiniteHits">
            <ol className="ais-InfiniteHits-list">
                {hits.map(hit => (
                    <li className="ais-InfiniteHits-item">
                        <CustomHit
                            hit={hit}
                            onSelected={onHitSelected}
                            searchConfig={searchConfig }
                        />
                    </li>
                ))}
            </ol>

            <Button
                className="ais-InfiniteHits-loadMore"
                onClick={showMore}
                onMouseDown={e => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                disabled={isLastPage}
                style={{ marginTop: 12 }}
            >
                Show more results
            </Button>
        </div>
    );
};

export default CustomInfiniteHits;